import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfVideo from '@elem/ui/ef-video';
import EFHouse from './icons/EFHouse';
import EFVans from './icons/EFVans';
import EFYacht from './icons/EFYacht';
import EFOther from './icons/EFOther';
import EFGrid from './icons/EFGrid';
import EFBattery from './icons/EFBattery';
import EFSolar from './icons/EFSolar';
import EFConsumption from './icons/EFConsumption';
import EFEarnings from './icons/EFEarnings';
import EFEnergy from './icons/EFEnergy';
import { createPortal } from 'react-dom';
import Modal1 from './Modal1';
import Modal2 from './Modal2';

type BoxItemType = {
    icon: JSX.Element;
    text: string;
};

type ImgItemType = {
    img: string;
    title?: string;
    text: string;
};

const C: React.FC = () => {
    const { t } = useLang('Oasis');
    const [enter, setEnter] = useState<number>(4);
    const [video1, setVideo1] = useState<string[]>(['', '']);
    const [video2, setVideo2] = useState<string[][]>([
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
    ]);
    const [video3, setVideo3] = useState<string[]>(['', '']);
    const [active2Item, setActive2Item] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<number>(0);

    const [box2BtnEnter, setBox2BtnEnter] = useState<boolean>(false);
    const [box4BtnEnter, setBox4BtnEnter] = useState<boolean>(false);

    const video2Arr: string[][] = [
        ['https://websiteoss.ecoflow.com/upload/video/1735782555660/C_2A.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784061083/C_2A_M.mp4'],
        ['https://websiteoss.ecoflow.com/upload/video/1735782556174/C_2B.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060891/C_2B_M.mp4'],
        ['https://websiteoss.ecoflow.com/upload/video/1735782555991/C_2C.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060402/C_2C_M.mp4'],
        ['https://websiteoss.ecoflow.com/upload/video/1735782555810/C_2D.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060561/C_2D_M.mp4'],
    ];

    const box2Items: BoxItemType[] = [
        {
            icon: <EFHouse />,
            text: t('C_box2_text1'),
        },
        {
            icon: <EFVans />,
            text: t('C_box2_text2'),
        },
        {
            icon: <EFYacht />,
            text: t('C_box2_text3'),
        },
        {
            icon: <EFOther />,
            text: t('C_box2_text4'),
        },
    ];

    const box3Items: BoxItemType[] = [
        {
            icon: <EFGrid />,
            text: t('C_box3_text1'),
        },
        {
            icon: <EFBattery />,
            text: t('C_box3_text2'),
        },
        {
            icon: <EFSolar />,
            text: t('C_box3_text3'),
        },
        {
            icon: <EFConsumption />,
            text: t('C_box3_text4'),
        },
        {
            icon: <EFEarnings />,
            text: t('C_box3_text5'),
        },
        {
            icon: <EFEnergy />,
            text: t('C_box3_text6'),
        },
    ];

    const box4Items: ImgItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640835265/C_4A.png',
            text: t('C_box4_text1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640834514/C_4B.png',
            text: t('C_box4_text2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640835063/C_4C.png',
            text: t('C_box4_text3'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640834874/C_4D.png',
            text: t('C_box4_text4'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640917200/C_4E.png',
            text: t('C_box4_text5'),
        },
    ];

    const handleOpenModal = (type: 1 | 2) => {
        setIsOpen(type);
    };

    const handleVideoPlay = (cls: string) => {
        const IS_PC = window?.innerWidth > 1024;
        const video: HTMLVideoElement | null = document.querySelector(`.page-oasis-C .${cls} .ef-video-item-${IS_PC ? 'pc' : 'h5'}`);
        if (video) {
            video.currentTime = 0;
            video.play();
        }
    };

    useEffect(() => {
        // 其实也可以写成AniContainer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.target.classList[0] === 'page-oasis-B' && video1?.some((v: string) => !v)) {
                    // 进入B模块时加载第一个视频
                    setVideo1([
                        'https://websiteoss.ecoflow.com/upload/video/1735870579125/C1.mp4',
                        'https://websiteoss.ecoflow.com/upload/video/1735870579297/C1_M.mp4',
                    ]);
                }
            });
        });

        const sectionB: HTMLDivElement | null = document.querySelector('.page-oasis-B');
        if (sectionB) {
            observer.observe(sectionB);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const container = '.page-oasis-C';
            const IS_PC = window?.innerWidth > 1024;
            // 进场enter + 加载资源
            const enter1 = AniContainer.create({
                triggerElement: '.page-oasis-C .box1',
                triggerHook: 1,
                offset: '0%',
                duration: '150%',
                onEnter: () => {
                    setEnter(1);
                    setVideo2(video2Arr);
                },
            });
            const enter2 = AniContainer.create({
                triggerElement: '.page-oasis-C .box2',
                triggerHook: 1,
                offset: '150%',
                duration: '100%',
                onEnter: () => {
                    setEnter(2);
                    setVideo3([
                        'https://websiteoss.ecoflow.com/upload/video/1742264564215/c-3M.mp4',
                        'https://websiteoss.ecoflow.com/upload/video/1742264564215/c-3M.mp4',
                    ]);
                },
            });

            // 进入开始播放视频
            const video1 = document.querySelector('.page-oasis-C .box1 .video-box') as HTMLDivElement;
            const playVideo1 = AniContainer.create({
                triggerElement: '.page-oasis-C .box1 .video-box',
                triggerHook: 1,
                offset: video1?.offsetHeight / 2,
                duration: IS_PC ? '100%' : '50%',
                onEnter: () => handleVideoPlay('box1'),
            });
            const video2 = document.querySelector('.page-oasis-C .box2 .video-box') as HTMLDivElement;
            const playVideo2 = AniContainer.create({
                triggerElement: '.page-oasis-C .box2 .video-box',
                triggerHook: 1,
                offset: IS_PC ? '150%' : video2?.offsetHeight / 2,
                duration: IS_PC ? '100%' : '50%',
                onEnter: () => handleVideoPlay('box2'),
            });
            const video3 = document.querySelector('.page-oasis-C .box3 .video-box') as HTMLDivElement;
            const playVideo3 = AniContainer.create({
                triggerElement: '.page-oasis-C .box3 .video-box',
                triggerHook: 1,
                offset: IS_PC ? '250%' : video3?.offsetHeight / 2,
                duration: '100%',
                onEnter: () => handleVideoPlay('box3'),
            });

            if (IS_PC) {
                // => 仅PC端
                // 滚动条控制动画
                const scroll = AniContainer.create({
                    asyncFromTo: [
                        ['.page-oasis-C .box1 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box1 视频秒现
                        ['.page-oasis-C .box1 .info .inner', { opacity: 0 }, { opacity: 1 }, 0.2], // box1 文案渐显
                        ['.page-oasis-C .box1 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box1 文案维持
                        ['.page-oasis-C .box1 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box1 文案渐隐
                        ['.page-oasis-C .box1 .video-box', { opacity: 1 }, { opacity: 0 }, 0.001], // box1 视频秒隐

                        ['.page-oasis-C .box2 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box2 视频秒现
                        ['.page-oasis-C .box2 .info .inner', { opacity: 0, y: 120 }, { opacity: 1, y: 0 }, 0.2], // box2 文案渐显
                        ['.page-oasis-C .box2 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box2 文案维持
                        ['.page-oasis-C .box2 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box2 文案渐隐
                        ['.page-oasis-C .box2 .video-box', { opacity: 1 }, { opacity: 0 }, 0.01], // box2 视频秒隐

                        ['.page-oasis-C .box3 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box3 视频秒现
                        ['.page-oasis-C .box3 .info .inner', { opacity: 0, y: 120 }, { opacity: 1, y: 0 }, 0.2], // box3 文案渐显
                        ['.page-oasis-C .box3 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box3 文案维持
                        ['.page-oasis-C .box3 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box3 文案渐隐
                        ['.page-oasis-C .box3 .video-box', { opacity: 1 }, { opacity: 0 }, 0.001], // box3 视频隐

                        ['.page-oasis-C .box4 .items', { opacity: 0 }, { opacity: 1 }, 0.001], // box4 图片秒现
                        // ['.page-oasis-C .box4 .items .item-2 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-2 上移
                        // ['.page-oasis-C .box4 .items .item-4 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-4 上移
                        ['.page-oasis-C .box4 .info', { opacity: 1 }, { opacity: 1 }, 1], // box4 维持
                    ],
                    asyncTimeLine: [
                        0, 0.5, 0.7, 1.3, 1.499,
                        // 0, 0.5, 0.65, 0.85, 0.9995,
                        // 1 - 2
                        1.499, 1.5, 1.7, 2.3, 2.499,
                        // 2- 3
                        2.499, 2.5, 2.7, 3.3, 3.499,
                        // 3 - 4
                        // 3.499, 3.75, 3.75, 4.5,
                        3.499, 4.5,
                    ],
                    triggerElement: container,
                    triggerHook: 1,
                    offset: 0,
                    duration: '550%',
                });
                // css 动画
                // box2 按钮 等文案全部显示后出现
                const box2BtnEnter = AniContainer.create({
                    triggerElement: container,
                    triggerHook: 1,
                    offset: '170%',
                    duration: '60%',
                    onEnter: () => setBox2BtnEnter(true),
                    onLeave: () => setBox2BtnEnter(false),
                });
                // enter3和enter4
                const enter3 = AniContainer.create({
                    triggerElement: '.page-oasis-C .box3',
                    triggerHook: 1,
                    offset: '250%',
                    duration: '100%',
                    onEnter: () => {
                        setEnter(3);
                        const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-C .box3 .ani-img');
                        if (aniImg) {
                            const styleObj = {
                                '1920': {
                                    bottom: '0%',
                                    left: '53.2%',
                                },
                                '1366': {
                                    bottom: '0%',
                                    left: '53%',
                                },
                            };
                            const screenWidth = window?.innerWidth > 1440 ? '1920' : '1366';
                            const curStyle = styleObj[screenWidth];
                            aniImg.style.bottom = curStyle.bottom;
                            aniImg.style.left = curStyle.left;
                            aniImg.style.opacity = 0;
                        }
                    },
                });
                // box3+box4 小图片位移+缩放+box4图片展开
                const enter4 = AniContainer.create({
                    triggerElement: '.page-oasis-C .box4',
                    triggerHook: 1,
                    offset: '350%',
                    duration: '500%',
                    onEnter: () => {
                        setEnter(4);
                        const timer = setInterval(() => {
                            const img3: HTMLLIElement | null = document.querySelector('.page-oasis-C .box4 .item-3');
                            const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-C .box3 .ani-img');
                            if (img3 && aniImg) {
                                const { offsetTop, offsetLeft } = img3;
                                aniImg.style.top = `${offsetTop}px`;
                                aniImg.style.left = `${offsetLeft}px`;
                                aniImg.style.opacity = 1;
                                clearInterval(timer);
                            }
                        }, 100);
                    },
                });
                // box4 按钮 等文案全部显示后出现
                const box4BtnEnter = AniContainer.create({
                    triggerElement: container,
                    triggerHook: 1,
                    offset: '350%',
                    duration: '90%',
                    onEnter: () => setBox4BtnEnter(true),
                    onLeave: () => setBox4BtnEnter(false),
                });
                return () => {
                    const sceneArr = [scroll, box2BtnEnter, enter3, enter4, box4BtnEnter];
                    sceneArr.forEach((scene) => scene.destroy());
                };
            }
            if (!IS_PC) {
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box4Lists: HTMLUListElement | null = document.querySelector('.page-oasis-C .box4 .items');
                const box4Item: HTMLUListElement | null = document.querySelector('.page-oasis-C .box4 .items .item');
                const box4ItemsScroll = AniContainer.create({
                    asyncFromTo: [
                        [
                            box4Lists,
                            { x: (winW - Number(box4Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box4Lists?.offsetWidth) + Number(box4Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.page-oasis-C .box4 .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.page-oasis-C .box4 .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.page-oasis-C .box4 .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-C .box4 .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-C .box4 .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.page-oasis-C .box4 .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-C .box4 .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-C .box4 .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.page-oasis-C .box4 .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.page-oasis-C .box4 .items-box',
                    triggerHook: 1,
                    duration: winH,
                    offset: '100%',
                });
                // box2 按钮 等文案全部显示后出现
                const box2BtnEnter = AniContainer.create({
                    triggerElement: '.page-oasis-C .box2 .btn',
                    triggerHook: 1,
                    offset: 120,
                    duration: '100%',
                    onEnter: () => setBox2BtnEnter(true),
                    onLeave: () => setBox2BtnEnter(false),
                });
                const box4BtnEnter = AniContainer.create({
                    triggerElement: '.page-oasis-C .box4 .btn',
                    triggerHook: 1,
                    offset: 120,
                    duration: '300%',
                    onEnter: () => setBox4BtnEnter(true),
                    onLeave: () => setBox4BtnEnter(false),
                });
                return () => {
                    box4ItemsScroll.destroy();
                    box2BtnEnter.destroy();
                    box4BtnEnter.destroy();
                };
            }
            return () => {
                const secneArr = [enter1, enter2, playVideo1, playVideo2, playVideo3];
                secneArr.forEach((scene) => scene.destroy());
            };
        }
    }, []);

    useEffect(() => {
        handleVideoPlay(`box2 .v${active2Item + 1}`);
    }, [active2Item]);

    return (
        <div className={`page-oasis-C ${css.section}`} id="page-oasis-C">
            <div className="sticky">
                <div className={`box box1 ${enter === 1 ? 'enter' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <div className="label">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M17 2H7C6.17157 2 5.5 2.67157 5.5 3.5V20.5C5.5 21.3284 6.17157 22 7 22H17C17.8284 22 18.5 21.3284 18.5 20.5V3.5C18.5 2.67157 17.8284 2 17 2Z"
                                        stroke="#4071FF"
                                        strokeWidth="2"
                                    />
                                    <path d="M11 5H13" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10 19H14" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span className="label-text">{t('C_box1_label')}</span>
                            </div>
                            <p className="title">{t(`C_box1_title`)}</p>
                            <p className="desc">
                                {t.rich(`C_box1_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="video-box">
                        {(video1[0] || video1[1]) && (
                            <EfVideo
                                pc={video1[0]}
                                h5={video1[1]}
                                poster="https://websiteoss.ecoflow.com/upload/image/1735870847487/C1.jpg"
                                posterH5="https://websiteoss.ecoflow.com/upload/image/1735870847185/C1_M.jpg"
                                preload="none"
                            />
                        )}
                    </div>
                </div>
                <div className={`box box2 ${enter === 2 ? 'enter' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box2_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box2_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                    sup: (tx: string) => <sup>{tx}</sup>,
                                })}
                            </p>
                            <ul className="items">
                                {box2Items.map((item: BoxItemType, k) => (
                                    <li className={`item${active2Item === k ? ' active' : ''}`} key={k} onClick={() => setActive2Item(k)}>
                                        {item.icon}
                                        <p className="item-text">{item.text}</p>
                                    </li>
                                ))}
                            </ul>
                            {/* <p className="tip">{t('C_box2_tip')}</p> */}
                        </div>
                    </div>
                    <div className="video-box">
                        {(video2[0][0] || video2[0][1]) && (
                            <EfVideo
                                className={`video v1 ${active2Item === 0 ? 'active' : ''}`}
                                pc={video2[0][0]}
                                h5={video2[0][1]}
                                poster="https://websiteoss.ecoflow.com/upload/image/1735782856514/C_2A.jpg"
                                posterH5="https://websiteoss.ecoflow.com/upload/image/1735784630938/C_2A_M.jpg"
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2[1][0] || video2[1][1]) && (
                            <EfVideo
                                className={`video v2 ${active2Item === 1 ? 'active' : ''}`}
                                pc={video2[1][0]}
                                h5={video2[1][1]}
                                poster="https://websiteoss.ecoflow.com/upload/image/1735782856901/C_2B.jpg"
                                posterH5="https://websiteoss.ecoflow.com/upload/image/1735784631224/C_2B_M.jpg"
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2[2][0] || video2[2][1]) && (
                            <EfVideo
                                className={`video v3 ${active2Item === 2 ? 'active' : ''}`}
                                pc={video2[2][0]}
                                h5={video2[2][1]}
                                poster="https://websiteoss.ecoflow.com/upload/image/1735782857073/C_2C.jpg"
                                posterH5="https://websiteoss.ecoflow.com/upload/image/1735784630738/C_2C_M.jpg"
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2[3][0] || video2[3][1]) && (
                            <EfVideo
                                className={`video v4 ${active2Item === 3 ? 'active' : ''}`}
                                pc={video2[3][0]}
                                h5={video2[3][1]}
                                poster="https://websiteoss.ecoflow.com/upload/image/1735782856691/C_2D.jpg"
                                posterH5="https://websiteoss.ecoflow.com/upload/image/1735784631339/C_2D_M.jpg"
                                loop={true}
                                preload="none"
                            />
                        )}
                    </div>
                    <button className={`btn ${box2BtnEnter ? 'enter' : ''}`} onClick={() => handleOpenModal(1)}>
                        <span className="btn-text">{t(`C_box2_btn`)}</span>
                        <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                    </button>
                </div>
                <div className={`box box3 ${enter === 3 ? 'enter' : ''} ${enter === 4 ? 'enterBox4' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box3_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box3_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                            <ul className="items">
                                {box3Items.map((item: BoxItemType, k) => (
                                    <li className="item" key={k}>
                                        {item.icon}
                                        <p className="item-text">{item.text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="video-box">
                        {(video3[0] || video3[1]) && (
                            <EfVideo pc={video3[0]} h5={video3[1]} poster="https://websiteoss.ecoflow.com/upload/image/1735783336706/C3.jpg" preload="none" />
                        )}
                    </div>
                    <div className="ani-img">
                        <div className="ani-box ani-1">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1735783336706/C3.jpg" />
                        </div>
                        <div className="ani-box ani-2">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1735640835063/C_4C.png" />
                        </div>
                        <div className="ani-box ani-3">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1735192448952/D_ani_small.png" />
                        </div>
                    </div>
                    <button className={`btn ${box4BtnEnter ? 'enter' : ''}`} onClick={() => handleOpenModal(2)}>
                        <span className="btn-text">{t('C_box4_btn')}</span>
                        <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                    </button>
                </div>
                <div className={`box box4 ${enter === 4 ? 'enter' : ''} ${enter === 4 ? 'enterBox4' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box4_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box4_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                        <div className="items-sticky">
                            <div className="items-box">
                                <ul className="items">
                                    {box4Items.map((item, k) => (
                                        <li className={`item item-${k + 1}`} key={k}>
                                            <div className={`item-inner item-inner-${k}`}>
                                                <div className="item-img">
                                                    <EfImg pc={item.img} />
                                                </div>
                                                <p className="item-text">{item.text}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <button className={`btn ${box4BtnEnter ? 'enter' : ''}`} onClick={() => handleOpenModal(2)}>
                                <span className="btn-text">{t('C_box4_btn')}</span>
                                <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen === 1 && createPortal(<Modal1 type={isOpen} callback={() => setIsOpen(0)} />, document.body)}
            {isOpen === 2 && createPortal(<Modal2 type={isOpen} callback={() => setIsOpen(0)} />, document.body)}
        </div>
    );
};

export default C;
